// extracted by mini-css-extract-plugin
module.exports = {"cherryColor":"index_cherryColor_3trdY","primaryColor":"index_primaryColor_16lZg"};